import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { TaskCategoryService } from '@fitness-force/api';
import { Store } from '@ngrx/store';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { BehaviorSubject, combineLatest } from 'rxjs';

@Component({
  selector: 'task-category-cell',
  templateUrl: './task-category-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class TaskCategoryCellComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);
  @Input() dataProperty: string;
  @Input() taskCategory = new BehaviorSubject(null);

  constructor(private store: Store, private taskCategoryService: TaskCategoryService) {}

  ngOnInit(): void {
    combineLatest([this.store.select(TENANTS_INFO), this.columnData]).subscribe(([tenant, colData]) => {
      const tenantId = tenant.selected_tenant.id;
      this.taskCategoryService.getTaskCategory(tenantId).subscribe((taskCategories: any) => {
        this.taskCategory.next(
          taskCategories.items.find((element: any) => colData && colData[this.dataProperty] === element.id)
        );
      });
    });
  }
}